import { HexColor } from '@repo/shared/types';
import { groq } from 'next-sanity';
import { z } from 'zod';

import { image, SanityImage } from './image';
import { media, SanityMedia } from './media';

export const SanityThreeUp = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('threeUp'),
  _key: z.string(),
  headline: z.string(),
  details: z.array(
    z.object({
      _key: z.string(),
      title: z.string(),
      caption: z.string(),
      icon: SanityImage.optional().nullable(),
      iconSize: z.number().optional().nullable(),
    }),
  ),
  media: SanityMedia.optional().nullable(),
  background: HexColor.optional().nullable(),
  foreground: HexColor.optional().nullable(),
});
export type SanityThreeUp = z.infer<typeof SanityThreeUp>;

export const threeUp = groq`{
  headline,
  details[] {
    _key,
    title,
    caption,
    icon ${image},
    iconSize,
  },
  media[0] ${media},
  'background': background -> color.hex,
  'foreground': foreground -> color.hex,
}`;
